import I18n from 'I18n';
export const getLanguageName = lang => I18n.lookup(`i18nAddon.languages.${lang}`) ? I18n.text(`i18nAddon.languages.${lang}`) : lang;